import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function TechRoleSearch({ searchObject, onChange, techAreas }) {
  let { t } = useTranslation();
  return (
    <ul className="list-inline mt-2">
      <li className="list-inline-item">
        <div className="form-group">
          <select
            required
            title={t("Selecione um item da lista.")}
            name="techAreaId"
            onChange={onChange}
            value={searchObject.techAreaId || ""}
          >
            <option key={0} value="" selected>
              {t("Tech Area...")}
            </option>
            {techAreas.map((techArea) => (
              <option key={techArea.id} value={techArea.id}>
                {t(techArea.description)}
              </option>
            ))}
          </select>
        </div>
      </li>
      <li className="list-inline-item">
        <div className="form-group">
          <input
            placeholder={t("Tech Role Name")}
            className="form-control"
            type="text"
            value={searchObject.description}
            onChange={onChange}
            name="description"
          />
        </div>
      </li>
    </ul>
  );
}
